import classNames from "classnames";
import styles from "./styles/GalleryBlock.module.scss";
import { EditButton } from "../EditButton";
import {
  getAltText,
  IReactiveMediaContentItem,
} from "../../../schoolfeed/SchoolFeedContentItem";
import { handleContentItemClick } from "../../SchoolBlocks/ContentItemBlock/ContentItemBlock";
import { SocialItemModalNavigationProps } from "../../../modals/SocialItemModal";
import { RefObject } from "react";
import { observer } from "mobx-react";
import ImageComponent from "../../../utilities/ImageComponent";
import { useStores } from "../../../../stores/useStores";
import { useTranslateClassName } from "../../../../hooks/useTranslateClassName";
import Markdown from "../../../utilities/Markdown";

const ImageGalleryItem = observer(
  (
    props: {
      item: IReactiveMediaContentItem;
      handleDelete: (contentItem: ContentItem) => void;
      ref: RefObject<HTMLDivElement | null>;
    } & SocialItemModalNavigationProps,
  ) => {
    const { userStore } = useStores();
    const translateClassName = useTranslateClassName();

    const imageWrapperClassName = classNames({
      [styles.imageWrapper]: true,
      [styles.imageWrapperHidden]: !props.item.published,
    });

    const imgSource = props.item.image || "";

    function handleClick(e) {
      if (e.key && e.key !== "Enter") return;
      e.preventDefault();
      handleContentItemClick(
        props.item as IReactiveMediaContentItem,
        {
          getItemAtIndex: props.getItemAtIndex,
          totalItemCount: props.totalItemCount,
          initialItemIndex: props.initialItemIndex,
        },
        props.handleDelete,
      );
    }

    return (
      <div
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleClick}
        ref={props.ref}
      >
        <div className={imageWrapperClassName}>
          <ImageComponent
            className={styles.item}
            key={props.item.id}
            src={imgSource}
            alt={getAltText(props.item)}
          />
          {(props.item.description || props.item.title) && (
            <div
              className={classNames(
                styles.photoDescription,
                translateClassName,
              )}
            >
              <div>{props.item.title}</div>
              {props.item.description && (
                <Markdown withStyles={true} source={props.item.description} />
              )}
            </div>
          )}
        </div>
        {userStore.isEditor && (
          <EditButton
            handleDelete={props.handleDelete}
            contentItem={props.item}
            className={styles.editButton}
          />
        )}
      </div>
    );
  },
);

export default ImageGalleryItem;
